import { Box } from '@mui/material';
import { BookOpen, NotepadText, Store } from 'lucide-react';
import LangEnum from '../../../../lang/LangEnum';
import useSharedEntities from '../../../../modules/shared-entities/hooks/useSharedEntities';
import useSharedEntitystore from '../../../../stores/SharedEntities/sharedEntities.store';
import { PublicAppBarTestIds } from '../../../../utils/testIds/publicAppBar.testIds';
import NavigationLogo from '../HomeNavigationHeader/components/NavigationLogo/NavigationLogo';
import PublicNavigationTab from './components/PublicNavigationTab';

const getCatalogLabel = (catalogName?: string) => {
  if (!catalogName) {
    return { label: LangEnum.GLOBAL_CATALOG };
  }

  return {
    label: LangEnum.GLOBAL_CATALOG_WITH_NAME,
    labelParams: { name: catalogName.toLocaleLowerCase() },
  };
};

const getOrderLabel = (orderCode?: string) => {
  if (!orderCode) {
    return { label: LangEnum.GLOBAL_SUGGESTED_ORDER_LABEL };
  }

  return {
    label: LangEnum.GLOBAL_SUGGESTED_ORDER_WITH_CODE,
    labelParams: { code: orderCode },
  };
};

const PublicNavigationHeader = () => {
  const sharedEntity = useSharedEntitystore((state) => state.sharedEntity);
  const {
    isCatalogActiveTab,
    isOrderActiveTab,
    isShowroomActiveTab,
    showCatalogTab,
    showOrderTab,
    showShowroomTab,
    handleRedirectToCatalog,
    handleRedirectToOrder,
    handleRedirectToShowroom,
  } = useSharedEntities({});

  if (!sharedEntity) {
    return null;
  }

  const catalogLabel = getCatalogLabel(sharedEntity.config.catalogName);
  const orderLabel = getOrderLabel(sharedEntity.config.code);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, gap: 2 }}>
      <NavigationLogo
        brand={{
          name: sharedEntity.brand?.commercialName ?? '',
          logoUrl: sharedEntity.brand?.logoUrl,
          logos: sharedEntity.brand?.logos,
        }}
        onClick={showShowroomTab ? handleRedirectToShowroom : undefined}
      />

      <Box sx={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
        {showCatalogTab && (
          <PublicNavigationTab
            icon={BookOpen}
            isActive={isCatalogActiveTab}
            testId={PublicAppBarTestIds.CATALOG_TAB}
            label={catalogLabel.label}
            labelParams={catalogLabel.labelParams}
            onClick={handleRedirectToCatalog}
          />
        )}

        {showOrderTab && (
          <PublicNavigationTab
            icon={NotepadText}
            isActive={isOrderActiveTab}
            testId={PublicAppBarTestIds.ORDER_TAB}
            label={orderLabel.label}
            labelParams={orderLabel.labelParams}
            onClick={handleRedirectToOrder}
          />
        )}

        {showShowroomTab && (
          <PublicNavigationTab
            icon={Store}
            isActive={isShowroomActiveTab}
            testId={PublicAppBarTestIds.SHOWROOM_TAB}
            label={LangEnum.SHOWROOM_REDIRECT}
            onClick={handleRedirectToShowroom}
          />
        )}
      </Box>
    </Box>
  );
};

export default PublicNavigationHeader;
